import { Stack } from "expo-router";
import React, { useState, useEffect, useRef } from "react";
import { View, Text, Image, Animated, BackHandler } from "react-native";
import { useFonts } from "expo-font";
import { Kanit_400Regular } from "@expo-google-fonts/kanit";
import { TouchableOpacity } from "react-native-gesture-handler";
import { GestureHandlerRootView } from "react-native-gesture-handler";
import { useRouter } from "expo-router";
import { useSelector, useDispatch } from "react-redux";
import { getProfile } from "./redux/actions/authactions";
import Ionicons from "react-native-vector-icons/Ionicons";
import { useLanguage } from "./screens/LanguageProvider";
import { SafeAreaProvider, SafeAreaView } from "react-native-safe-area-context";
import "../global.css";

export default function stack() {
  const [isLoading, setIsLoading] = useState(true);
  const fadeAnim = useRef(new Animated.Value(0)).current;
  const scaleAnim = useRef(new Animated.Value(0.8)).current;
  const router = useRouter();
  const dispatch = useDispatch();
  const token = useSelector((state: any) => state?.auth?.user?.token) || null;
  const { t, setLang, currentLang } = useLanguage();

  const profile =
    useSelector((state: any) => state?.auth?.profile?.user?.[0]) || null;

  useEffect(() => {
    // โหลดข้อมูลโปรไฟล์ถ้ามี token
    if (token) {
      dispatch(getProfile(token) as any);
    }

    // เริ่มทำ Animation
    Animated.parallel([
      Animated.timing(fadeAnim, {
        toValue: 1,
        duration: 1000,
        useNativeDriver: true,
      }),
      Animated.timing(scaleAnim, {
        toValue: 1,
        duration: 1000,
        useNativeDriver: true,
      }),
    ]).start();

    // ตั้งเวลาให้โหลดเสร็จใน 2 วินาที
    const timer = setTimeout(() => setIsLoading(false), 2000);

    // ป้องกันการกดปุ่ม Back บน Android
    const backAction = () => true;
    const backHandler = BackHandler.addEventListener(
      "hardwareBackPress",
      backAction
    );

    return () => {
      clearTimeout(timer); // ล้าง Timer
      backHandler.remove(); // ลบ Event Listener ปุ่ม Back
    };
  }, [token]);

  const [fontsLoaded] = useFonts({
    Kanit: Kanit_400Regular,
  });

  if (!fontsLoaded) return null;

  if (isLoading) {
    return (
      <SafeAreaView
        className="flex-1 items-center justify-center bg-[#F17736]"
        edges={["top", "bottom", "left", "right"]} // กำหนดให้ครอบคลุมทุกด้าน
      >
        <Animated.Image
          source={require("../assets/logowhite.png")} // เปลี่ยนเป็นโลโก้ของคุณ
          style={{
            width: 160,
            height: 160,
            // marginBottom: 20,
            opacity: fadeAnim, // ใช้ Fade-in
            transform: [{ scale: scaleAnim }], // ใช้ Scale-up
          }}
          resizeMode="contain"
        />
      </SafeAreaView>
    );
  }

  return (
    <SafeAreaProvider>
      <GestureHandlerRootView style={{ flex: 1 }}>
        <Stack
          initialRouteName="screens/login"
          screenOptions={{
            headerShown: false,
          }}
        >
          <Stack.Screen
            name="screens/login"
            options={{
              title: "",
              headerShown: true,
              headerStyle: {
                backgroundColor: "#F17736",
              },
              headerTintColor: "#fff",
              headerTitleStyle: {
                fontFamily: "Kanit",
              },
              headerShadowVisible: false, // ปิดเส้นขอบด้านล่าง
              headerBackVisible: false, // 🚀 ปิดปุ่ม Back
              headerRight() {
                return (
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      paddingRight: 10,
                      gap: 8,
                    }}
                  >
                    {[
                      {
                        code: "th",
                        label: "ไทย",
                        icon: require("../assets/thailand.png"),
                      },
                      {
                        code: "en",
                        label: "English",
                        icon: require("../assets/united-kingdom.png"),
                      },
                      {
                        code: "my",
                        label: "Myanmar",
                        icon: require("../assets/myanmar.png"),
                      },
                    ].map((lang) => {
                      const isSelected = currentLang === lang.code;
                      return (
                        <TouchableOpacity
                          key={lang.code}
                          onPress={() =>
                            setLang(lang.code as "th" | "en" | "my")
                          }
                          activeOpacity={0.85}
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            backgroundColor: isSelected
                              ? "#fff"
                              : "rgba(255,255,255,0.15)",
                            paddingHorizontal: 12,
                            paddingVertical: 6,
                            borderRadius: 18,
                            borderWidth: isSelected ? 1 : 0,
                            borderColor: "#fff",
                            shadowColor: "#000",
                            shadowOffset: { width: 0, height: 1 },
                            shadowOpacity: 0.2,
                            shadowRadius: 2,
                            elevation: 3,
                          }}
                        >
                          <Image
                            source={lang.icon}
                            style={{
                              width: 18,
                              height: 18,
                              marginRight: 6,
                            }}
                            resizeMode="contain"
                          />
                          <Text
                            style={{
                              color: isSelected ? "#F17736" : "#fff",
                              fontFamily: "Kanit",
                              fontSize: 13,
                              // fontWeight: isSelected ? "700" : "400",
                            }}
                          >
                            {lang.label}
                          </Text>
                        </TouchableOpacity>
                      );
                    })}
                  </View>
                );
              },
            }}
          />
          <Stack.Screen
            name="screens/home"
            options={{
              title: "",
              headerShown: true,
              headerStyle: {
                backgroundColor: "#F17736",
              },
              headerTintColor: "#fff",
              headerTitleStyle: {
                // fontWeight: "bold",
                fontFamily: "Kanit",
              },
              headerShadowVisible: false, // ปิดเส้นขอบด้านล่าง
              headerLeft: () => (
                <View className="flex-1 items-start">
                  <Text
                    className="text-white font-kanit text-sm"
                    style={{ lineHeight: 16 }}
                  >
                    {/* ยินดีต้อนรับ */}
                    {t("welcome")}
                  </Text>
                  <Text
                    className="text-white font-kanit text-xl"
                    style={{ lineHeight: 22 }}
                  >
                    {profile?.FullNameEng}
                  </Text>
                </View>
              ),
              headerRight: () => (
                <>
                  <TouchableOpacity
                    onPress={() => router.push("/screens/profile")}
                    className=" rounded-full"
                  >
                    <Image
                      source={{
                        uri: `https://emp-image.veninecopper.com/${profile?.EmpCode}.png`,
                      }}
                      className="w-14 h-14 rounded-full border-white bg-white border-2"
                      resizeMode="contain"
                    />
                  </TouchableOpacity>
                </>
              ),
            }}
          />
          <Stack.Screen
            name="screens/profile"
            options={{
              // title: "โปรไฟล์",
              title: t("profile"),
              headerShown: true,
              headerStyle: {
                backgroundColor: "#F17736",
              },
              headerTintColor: "#fff",
              headerTitleStyle: {
                // fontWeight: "bold",
                fontFamily: "Kanit",
              },
              headerTitleAlign: "center",
              headerShadowVisible: false, // ปิดเส้นขอบด้านล่าง
            }}
          />
          <Stack.Screen
            name="screens/orderprint"
            options={{
              // title: "ปริ้นป้ายแท็ก",
              title: t("print_label"),
              headerShown: true,
              headerStyle: {
                backgroundColor: "#F17736",
              },
              headerTintColor: "#fff",
              headerTitleStyle: {
                // fontWeight: "bold",
                fontFamily: "Kanit",
              },
              headerTitleAlign: "center",
              headerShadowVisible: false, // ปิดเส้นขอบด้านล่าง
              headerBackVisible: false, // 🚀 ปิดปุ่ม Back แน่นอ
            }}
          />
          <Stack.Screen
            name="screens/menuprofile"
            options={{
              // title: "โปรไฟล์",
              title: t("profile"),
              headerShown: true,
              headerStyle: {
                backgroundColor: "#F17736",
              },
              headerTintColor: "#fff",
              headerTitleStyle: {
                // fontWeight: "bold",
                fontFamily: "Kanit",
              },
              headerTitleAlign: "center",
              headerShadowVisible: false, // ปิดเส้นขอบด้านล่าง
              headerBackVisible: false, // 🚀 ปิดปุ่ม Back แน่นอ
            }}
          />
          <Stack.Screen
            name="screens/order_scales"
            options={{
              // title: "รายการชั่งน้ำหนัก",
              title: t("order_scales"),
              headerShown: true,
              headerStyle: {
                backgroundColor: "#F17736",
              },
              headerTintColor: "#fff",
              headerTitleStyle: {
                // fontWeight: "bold",
                fontFamily: "Kanit",
              },
              headerTitleAlign: "center",
              headerShadowVisible: false, // ปิดเส้นขอบด้านล่าง
              headerBackVisible: false, // ซ่อนปุ่มย้อนกลับเริ่มต้น
              headerLeft: () => (
                <TouchableOpacity
                  onPress={() => router.push("/screens/home")}
                  style={{ marginLeft: 10 }} // ให้ปุ่มไม่ติดขอบซ้ายมากเกินไป
                >
                  <Ionicons name="arrow-back" size={24} color="#fff" />
                </TouchableOpacity>
              ),
            }}
          />
          <Stack.Screen
            name="screens/detailorder"
            options={{
              // title: "รายละเอียด",
              title: t("detail"),
              headerShown: true,
              headerStyle: {
                backgroundColor: "#F17736",
              },
              headerTintColor: "#fff",
              headerTitleStyle: {
                // fontWeight: "bold",
                fontFamily: "Kanit",
              },
              headerTitleAlign: "center",
              headerShadowVisible: false, // ปิดเส้นขอบด้านล่าง
            }}
          />
          <Stack.Screen
            name="screens/retrieve"
            options={{
              // title: "ชั่งน้ำหนัก",
              title: t("weight_scales"),
              headerShown: true,
              headerStyle: {
                backgroundColor: "#F17736",
              },
              headerTintColor: "#fff",
              headerTitleStyle: {
                // fontWeight: "bold",
                fontFamily: "Kanit",
              },
              headerTitleAlign: "center",
              headerShadowVisible: false, // ปิดเส้นขอบด้านล่าง
              headerBackVisible: false, // 🚀 ปิดปุ่ม Back แน่นอน
            }}
          />
          <Stack.Screen
            name="screens/goodworksuccess"
            options={{
              // title: "สถานะการรับของ",
              title: t("status_accept"),
              headerShown: true,
              headerStyle: {
                backgroundColor: "#F17736",
              },
              headerTintColor: "#fff",
              headerTitleStyle: {
                // fontWeight: "bold",
                fontFamily: "Kanit",
              },
              headerTitleAlign: "center",
              headerShadowVisible: false, // ปิดเส้นขอบด้านล่าง
              headerBackVisible: false, // 🚀 ปิดปุ่ม Back แน่นอน
            }}
          />
          <Stack.Screen
            name="screens/location"
            options={{
              // title: "สถานที่จัดเก็บ",
              title: t("location"),
              headerShown: true,
              headerStyle: {
                backgroundColor: "#F17736",
              },
              headerTintColor: "#fff",
              headerTitleStyle: {
                // fontWeight: "bold",
                fontFamily: "Kanit",
              },
              headerTitleAlign: "center",
              headerShadowVisible: false, // ปิดเส้นขอบด้านล่าง
            }}
          />
          <Stack.Screen
            name="screens/print"
            options={{
              // title: "พิมพ์ใบชี้บ่งผลิตภัณฑ์",
              title: t("print_label"),
              headerShown: true,
              headerStyle: {
                backgroundColor: "#F17736",
              },
              headerTintColor: "#fff",
              headerTitleStyle: {
                // fontWeight: "bold",
                fontFamily: "Kanit",
              },
              headerTitleAlign: "center",
              headerShadowVisible: false, // ปิดเส้นขอบด้านล่าง
            }}
          />
          <Stack.Screen
            name="screens/detaillocation"
            options={{
              // title: "รายละเอียด",
              title: t("detail"),
              headerShown: true,
              headerStyle: {
                backgroundColor: "#F17736",
              },
              headerTintColor: "#fff",
              headerTitleStyle: {
                // fontWeight: "bold",
                fontFamily: "Kanit",
              },
              headerTitleAlign: "center",
              headerShadowVisible: false, // ปิดเส้นขอบด้านล่าง
            }}
          />
          <Stack.Screen
            name="screens/scanlocation"
            options={{
              // title: "สแกนสถานที่",
              title: t("scan_location"),
              headerShown: true,
              headerStyle: {
                backgroundColor: "#F17736",
              },
              headerTintColor: "#fff",
              headerTitleStyle: {
                // fontWeight: "bold",
                fontFamily: "Kanit",
              },
              headerTitleAlign: "center",
              headerShadowVisible: false, // ปิดเส้นขอบด้านล่าง
            }}
          />
          <Stack.Screen
            name="screens/successprocess"
            options={{
              // title: "สถานะการจัดเก็บ",
              title: t("status_location"),
              headerShown: true,
              headerStyle: {
                backgroundColor: "#F17736",
              },
              headerTintColor: "#fff",
              headerTitleStyle: {
                // fontWeight: "bold",
                fontFamily: "Kanit",
              },
              headerTitleAlign: "center",
              headerShadowVisible: false, // ปิดเส้นขอบด้านล่าง
              headerBackVisible: false, // 🚀 ปิดปุ่ม Back แน่นอน
            }}
          />
          <Stack.Screen
            name="screens/print_order"
            options={{
              // title: "พิมพ์ใบชี้บ่งผลิตภัณฑ์",
              title: t("print_label"),
              headerShown: true,
              headerStyle: {
                backgroundColor: "#F17736",
              },
              headerTintColor: "#fff",
              headerTitleStyle: {
                // fontWeight: "bold",
                fontFamily: "Kanit",
              },
              headerTitleAlign: "center",
              headerShadowVisible: false, // ปิดเส้นขอบด้านล่าง
            }}
          />
          <Stack.Screen
            name="screens/detailprint"
            options={{
              // title: "รายละเอียด",
              title: t("detail"),
              headerShown: true,
              headerStyle: {
                backgroundColor: "#F17736",
              },
              headerTintColor: "#fff",
              headerTitleStyle: {
                // fontWeight: "bold",
                fontFamily: "Kanit",
              },
              headerTitleAlign: "center",
              headerShadowVisible: false, // ปิดเส้นขอบด้านล่าง
            }}
          />
          <Stack.Screen
            name="screens/scancheck"
            options={{
              // title: "สแกนป้ายชี้บ่งผลิตภัณฑ์",
              title: t("scan_label"),
              headerShown: true,
              headerStyle: {
                backgroundColor: "#F17736",
              },
              headerTintColor: "#fff",
              headerTitleStyle: {
                // fontWeight: "bold",
                fontFamily: "Kanit",
              },
              headerTitleAlign: "center",
              headerShadowVisible: false, // ปิดเส้นขอบด้านล่าง
              headerBackVisible: false, // 🚀 ปิดปุ่ม Back แน่นอน
            }}
          />
          <Stack.Screen
            name="screens/processwipsuccess"
            options={{
              title: "สถานะการจัดเก็บ",
              headerShown: true,
              headerStyle: {
                backgroundColor: "#F17736",
              },
              headerTintColor: "#fff",
              headerTitleStyle: {
                // fontWeight: "bold",
                fontFamily: "Kanit",
              },
              headerTitleAlign: "center",
              headerShadowVisible: false, // ปิดเส้นขอบด้านล่าง
            }}
          />
        </Stack>
      </GestureHandlerRootView>
    </SafeAreaProvider>
  );
}
